import { getApi, postApi, putApi } from "./apis";
const requestCache = new Map();

const cacheKey = (endpoint: string, params?: any) => {
  return `${endpoint}${params ? JSON.stringify(params) : ""}`;
};

const withCache = async (key: string, request: () => Promise<any>) => {
  if (requestCache.has(key)) {
    return requestCache.get(key);
  }

  const promise = request();
  requestCache.set(key, promise);

  try {
    const result = await promise;
    setTimeout(() => requestCache.delete(key), 2000);
    return result;
  } catch (error) {
    requestCache.delete(key);
    throw error;
  }
};
export const postNewFarmData = async (data: any) => {
    try {
        return await postApi('LandlordPartnerMapping/Add', data);
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Failed to post data : ${error.message}`);
        } else {
            throw new Error('Failed to post data : unknown error occured');
        }
    }
}

export const saveNewLandlordFieldMapping = async (data: any) => {
  try {
    return await postApi("FieldMapping", data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to save data : ${error.message}`);
    } else {
      throw new Error("Failed to save data : unknown error occured");
    }
  }
};

export const fetchBillingEntityData = async () => {
  const endpoint = `Billing/Get`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
};

export const fetchUnMappedFieldsData = async () => {
  const endpoint = `Field/get-unmapped-fields`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
};

export const fetchCropYearData =  async () => {
  const endpoint = `CropYear/Get`;
    return withCache(cacheKey(endpoint), async () => {
      try {
        return await getApi(endpoint);
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw new Error(`Failed to fetch data: ${error.message}`);
        }
        throw new Error("Failed to fetch data: unknown error occurred");
      }
    });
}
export const fetchFarmData =  async () => {
  const endpoint = `masterdata/farms`;
    return withCache(cacheKey(endpoint), async () => {
      try {
        return await getApi(endpoint);
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw new Error(`Failed to fetch data: ${error.message}`);
        }
        throw new Error("Failed to fetch data: unknown error occurred");
      }
    });
}
export const postNewBillingEntityData= async (data: any) => {
  try {
    const res= await postApi('Billing/Add', data);
    return res;
} catch (error: unknown) {
    if (error instanceof Error) {
        throw new Error(`Failed to post data : ${error.message}`);
    } else {
        throw new Error('Failed to post data : unknown error occured');
    }
}
};
export const postNewFarmNameData= async (data: any) => {
  try {
    const res= await postApi('Landlord/Add', data);
    return res;
} catch (error: unknown) {
    if (error instanceof Error) {
        throw new Error(`Failed to post data : ${error.message}`);
    } else {
        throw new Error('Failed to post data : unknown error occured');
    }
}
};

export const renameLandlordData = async (data: { id: number; landlordName: string }) => {
  try {
    const res = await putApi('Landlord/Update', data);
    return res;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to rename landlord: ${error.message}`);
    }
    throw new Error('Failed to rename landlord: unknown error occurred');
  }
};

export const renameBillingEntityData = async (data: { id: number; billingName: string }) => {
  try {
    const res = await putApi('Billing/Update', data);
    return res;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to rename billing entity: ${error.message}`);
    }
    throw new Error('Failed to rename billing entity: unknown error occurred');
  }
};